import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSlider } from '../hooks';
import { resolveImg } from '../utils/img';
import { C } from '../config/constants';

export default function Slider({ fotos }) {
  const images = fotos?.length ? fotos : ['foto1.png'];
  const { current, setCurrent, goNext, goPrev } = useSlider(images.length);

  return (
    <div className="slider-wrap" style={{
      position: 'relative', borderRadius: C.radius, overflow: 'hidden',
      boxShadow: C.shadowLg,
    }}>
      <div className="slider-track" style={{ transform: `translateX(-${current * 100}%)` }}>
        {images.map((img, i) => (
          <img key={i} src={resolveImg(img)} alt={`Foto ${i + 1}`} />
        ))}
      </div>

      {images.length > 1 && <>
        <button className="slider-btn" onClick={goPrev} aria-label="Anterior" style={{
          position:'absolute', top:'50%', left:'12px', transform:'translateY(-50%)',
          background:'rgba(255,255,255,0.9)', backdropFilter:'blur(6px)',
          border:'none', borderRadius:'50%', width:'40px', height:'40px',
          color:C.blau, cursor:'pointer',
          display:'flex', alignItems:'center', justifyContent:'center',
          boxShadow:'0 4px 12px rgba(0,0,0,0.15)',
        }}><ChevronLeft size={20}/></button>
        <button className="slider-btn" onClick={goNext} aria-label="Següent" style={{
          position:'absolute', top:'50%', right:'12px', transform:'translateY(-50%)',
          background:'rgba(255,255,255,0.9)', backdropFilter:'blur(6px)',
          border:'none', borderRadius:'50%', width:'40px', height:'40px',
          color:C.blau, cursor:'pointer',
          display:'flex', alignItems:'center', justifyContent:'center',
          boxShadow:'0 4px 12px rgba(0,0,0,0.15)',
        }}><ChevronRight size={20}/></button>

        <div style={{
          position:'absolute', bottom:'14px', left:'50%', transform:'translateX(-50%)',
          display:'flex', gap:'6px',
          background:'rgba(255,255,255,0.85)', backdropFilter:'blur(6px)',
          padding:'6px 10px', borderRadius:'999px',
        }}>
          {images.map((_, i) => (
            <button key={i} className={`dot ${i===current?'active':''}`}
              onClick={() => setCurrent(i)} aria-label={`Foto ${i+1}`} />
          ))}
        </div>
      </>}
    </div>
  );
}